<template>
  <transition-fade :duration="500" appear expand>
    <div v-if="items.length" id="facets-in-use" class="w-full">
      <div class="wrap mt-[-1vh] pb-[30px]">
        Resultaat verfijnd op:

        <transition-group name="list-facets-applied" tag="div" class="contents">
          <router-link
            v-for="facet in items"
            :key="facet.key"
            :to="facet.route"
            class="facet-link btn btn-circle font-bold before:content-['×_'] before:font-black first:ml-[.4vw]"
          >
            <slot :name="facet.type" :item="facet.item" />
          </router-link>
          <router-link-button
            key="remove-all"
            :to="{
              ...$route,
              query: {
                zoek: query,
              },
            }"
            class="remove-all mt-[1vh] py-[8px] px-[15px] before:content-['×_'] before:font-black"
          >
            Verwijder alle filters
          </router-link-button>
        </transition-group>
      </div>
    </div>
  </transition-fade>
</template>

<script>
import RouterLinkButton from "../RouterLinkButton.vue";
import TransitionFade from "../../magic/TransitionFade.vue";

export default {
  name: "MediaArchiveFacetsApplied",
  components: {
    RouterLinkButton,
    TransitionFade,
  },
  props: {
    items: {
      type: Array,
    },
    query: {
      type: String,
    },
  },
};
</script>

<style scoped lang="css">
/* Transitions */

.list-facets-applied-enter-active,
.list-facets-applied-leave-active {
  opacity: 1;
  transition: opacity 300ms ease;
}

.list-facets-applied-move {
  transition: transform 0.3s ease;
}

.list-facets-applied-enter-from,
.list-facets-applied-leave-to {
  opacity: 0;
}

.list-facets-applied-leave-active {
  position: absolute;
  transition-duration: 200ms;
}
</style>
